import { render } from "./App.vue?vue&type=template&id=106882dd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=106882dd&lang=scss"

import exportComponent from "/app/jenkins/workspace/fe-recovery-official-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__